import React from 'react'
import { useAuth } from '../../hooks/useAuth'

// Torox iframe wall. IDs come from the Torox dashboard (App Placement section).
// Set REACT_APP_TOROX_PUB_ID / REACT_APP_TOROX_APP_ID in cashoutnow-frontend/.env,
// or replace the fallbacks below.
// Format: https://torox.io/ifr/show/PUB_ID/UserID/APP_ID/0/0/subid1/subid2/subid3
const TOROX_PUB_ID = process.env.REACT_APP_TOROX_PUB_ID || '30961';
const TOROX_APP_ID = process.env.REACT_APP_TOROX_APP_ID || '16934';

export default function Torox() {
    const { user } = useAuth();
  return (
    <iframe width="100%" height="1000px" title="Torox Offer Wall" allow="clipboard-write" src={`https://torox.io/ifr/show/${TOROX_PUB_ID}/${user.id}/${TOROX_APP_ID}/0/0`} frameBorder="0"></iframe>
  )
}
